import PlataformApi from '@/services/plataformApi'
import Constants from '@/core/constants/constants'

const Header = {
  components: {
    PlataformApi
  },
  
  state: () => ({
    headerState: Constants.INIT,
    footerState: false,
    darkMode: false,
  }),

  getters: {
    darkMode: state => {
      return state.darkMode
    }
  },

  mutations: {
    setHeaderState (state, headerState) {
      state.headerState = headerState
    },
    setFooterState (state, footerState) {
      state.footerState = footerState
    },
    setDarkMode (state, darkMode) {
      state.darkMode = darkMode
    },
  },

  actions: {
    updateHeader ({ commit }, headerState) {
      commit('setHeaderState', headerState)
    },
    updateFooter ({ commit }, footerState) {
      commit('setFooterState', footerState)
    },
    async toggleDarkMode ({ commit }) {
      let response = await PlataformApi.toggleDarkMode()
      commit('setDarkMode', response)
    }
  }
};

export default Header;